import declarations from './templates.json' with {type:'json'};
import {VOCABULARIES,resolveSlots,matchesSlot} from './index.js';
export const TEMPLATE_CONTEXTS=declarations;
const escape=text=>text.replaceAll('&','&amp;').replaceAll('<','&lt;').replaceAll('>','&gt;').replaceAll('"','&quot;');
const marker=/<span data-math-theme-slot="([a-z0-9_]+):([a-z]+):(singular|plural)">([^<]*)<\/span>/g;
export function themeWord(templateId,name,form='plural'){
 const template=TEMPLATE_CONTEXTS[templateId],slot=template?.slots[name];
 if(!slot||!template.roles.includes(slot.role))throw new Error(`Undeclared theme slot ${templateId}/${name}`);
 const word=VOCABULARIES.generic.find(word=>word.id===slot.generic&&matchesSlot(word,slot));
 if(!word||!['singular','plural'].includes(form))throw new Error('Invalid generic word or noun form');
 return `<span data-math-theme-slot="${templateId}:${name}:${form}">${escape(word[form])}</span>`;
}
export function renderThemeHtml(html,theme='generic'){
 return html.replace(marker,(_match,id,name,form,generic)=>{
  const template=TEMPLATE_CONTEXTS[id];if(!template?.slots[name])throw new Error(`Undeclared rendered slot ${id}/${name}`);
  // Resolve the ENTIRE template, even when this fragment only uses one slot.
  const selected=resolveSlots(template,theme,id)[name];
  const expected=themeWord(id,name,form).match(marker)?.[0];
  if(expected!==_match)throw new Error(`Changed generic vocabulary in ${id}/${name}`);
  return selected?escape(selected.word[form]):generic;
 });
}
// Authored opt-in slots only; no blanket substitution of an interest noun.
export function annotateContext(p){
 const template=TEMPLATE_CONTEXTS[p.topic];if(!template)return p;
 if(template.policy==='pictures'){
  const generic=html=>String(html).split(/(<[^>]*>)/g).map(part=>part.startsWith('<')?part:part.replace(/\b(?:basketballs?|balls?)\b/gi,word=>word[0]===word[0].toUpperCase()?(word.endsWith('s')?'Objects':'Object'):(word.endsWith('s')?'objects':'object'))).join('').replace(/\b1 objects\b/g,'1 object').replace(/\bThere are 1 object\b/g,'There is 1 object').replace(/\ba object\b/g,'an object').replace(/\bA object\b/g,'An object');
  const math=generic(p.math).replace(/aria-label="([^"]*)"/g,(_m,label)=>`aria-label="${generic(label)}"`).replace('<image href="/learning/sports/basketball.png"','<image data-counting-piece="true" href="/learning/sports/basketball.png"');
  return {...p,ask:generic(p.ask),math,...(p.visual?.label?{visual:{...p.visual,label:generic(p.visual.label)}}:{}),steps:p.steps.map(generic),teaching:{...p.teaching,idea:generic(p.teaching.idea),pitfalls:p.teaching.pitfalls.map(generic)}};
 }
 if(template.policy!=='word'||p.ask.includes('data-math-theme-slot'))return p;
 const annotate=html=>String(html).split(/(<[^>]*>)/g).map(part=>part.startsWith('<')?part:part.replace(/\b[A-Za-z]+\b/g,token=>{
  for(const [name,slot] of Object.entries(template.slots)){
   const word=VOCABULARIES.generic.find(word=>word.id===slot.generic);
   for(const form of ['singular','plural'])if(token===word?.[form])return themeWord(p.topic,name,form);
  }
  return token;
 })).join('');
 return {...p,ask:annotate(p.ask),steps:p.steps.map(annotate),teaching:{...p.teaching,idea:annotate(p.teaching.idea),pitfalls:p.teaching.pitfalls.map(annotate)},traps:p.traps.map(trap=>({...trap,note:annotate(trap.note)}))};
}
